import { DateTimeValue, DateValue } from "@/components/tableDrawer"

const TextCell = (accessor: string, header?: string) => ({ Header: header || accessor, accessor: accessor })
const SearchableTextCell = (accessor: string, header?: string) => ({ ...TextCell(accessor, header), canSearch: true, probName: accessor })
const HiddenSearchableText = (accessor, header) => ({ ...SearchableTextCell(accessor, header), visible: false })





const DateCell = (accessor: string, header?: string) => ({ ...CustomCell(accessor || header, r => DateValue({ value: r[accessor] })) })
const DateTimeCell = (accessor: string, header?: string) => ({ ...CustomCell(accessor || header, r => DateTimeValue({ value: r[accessor] })) })

const DateSearchableCell = (accessor: string, header?: string) => ({ ...DateCell(accessor, header), accessor: header || accessor, canSearch: true, type: "Date" })
const DateSearchableRangeCell = (accessor: string, header?: string) => ({ ...DateSearchableCell(accessor, header), isMulti: true })

const HiddenDateSearchableCell = (accessor: string) => ({ ...DateSearchableCell(accessor), visible: false })
const HiddenDateSearchableRangeCell = (accessor: string) => ({ ...HiddenDateSearchableCell(accessor), isMulti: true })

const DropDownCell = (accessor: string, probName: string, header?: string, options: any[] = [], defaultValue?: any) => ({Header: header || accessor,probName: probName || accessor,accessor: accessor,options: options,type: "DropDown",canSearch: true,defaultValue: defaultValue,})

const DropDownMultiCell = (accessor: string, probName: string, header?: string, options: any[] = [], defaultValue?: any) => ({...DropDownCell(accessor, probName, header, options, defaultValue), isMulti: true})
const HiddenDropDownCell = (accessor: string, probName: string, header?: string, options: any[] = [], defaultValue?: any) => ({ ...DropDownCell(accessor, probName, header, options, defaultValue), isMulti: false, visible: false })
const HiddenDropDownMultiCell = (accessor: string, probName: string, header?: string, options: any[] = [], defaultValue?: any) => ({ ...DropDownMultiCell(accessor, probName, header, options, defaultValue), visible: false })

const CustomCell = (header, component) => ({ Header: header, Cell: ({ row: { original } }) => component(original) })

const CheckboxColumn = (HeaderCell, RowCell) => ({
    id: "select",
    Header: ({ getToggleAllPageRowsSelectedProps }) => HeaderCell({ getToggleAllPageRowsSelectedProps }),
    Cell: ({ row }) => RowCell({ row })
})

export const ColumnsGenerator = {
    TextCell,
    SearchableTextCell,
    HiddenSearchableText,
    CustomCell,
    CheckboxColumn,

    DateCell,
    DateTimeCell,
    DateSearchableCell,
    DateSearchableRangeCell,
    HiddenDateSearchableCell,
    HiddenDateSearchableRangeCell,

    DropDownCell,
    DropDownMultiCell,
    HiddenDropDownCell,
    HiddenDropDownMultiCell,
}